import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
export var CONTENT_PREVIEW_PARAMETER = "contentPreview";
var COMPANY_COMPANY_LOGO_URL_PATH = "/content/entries/companyLogo";
var INTEGRATION_COMPANY_LOGO_URL_PATH = "/content/entries/integrationLogoGlobal";
var CARD_URL_PATH = "/content/entries/card";
var EMBED_VIDEO_URL_PATH = "/content/entries/embeddedVideo";
var DOWNLOAD_ON_SUBMIT_FORM_URL_PATH = "/content/entries/downloadOnSubmitForm";
var BLANK_MEDIA = {
  title: "",
  src: "",
  contentType: "",
  width: 0,
  height: 0
};
export var getBaseMediaType = function getBaseMediaType(contentType) {
  return contentType ? contentType.split("/")[0] : "unknown";
};
export var convertAssetToMedia = function convertAssetToMedia(asset) {
  return asset ? {
    title: _get(asset, "fields.title", ""),
    src: _get(asset, "fields.file.url", ""),
    contentType: _get(asset, "fields.file.contentType", ""),
    width: _get(asset, "fields.file.details.image.width", ""),
    height: _get(asset, "fields.file.details.image.height", "")
  } : BLANK_MEDIA;
};
export var convertEmbedVideoToMedia = function convertEmbedVideoToMedia(embedVideo) {
  return embedVideo ? {
    title: _get(embedVideo, "name", ""),
    src: _get(embedVideo, "embedUrl", ""),
    contentType: "Embed Video",
    width: 0,
    height: 0,
    structuredData: _get(embedVideo, "structuredData", {})
  } : BLANK_MEDIA;
};

var deriveIdFromUrn = function deriveIdFromUrn(urn) {
  var urnParts = urn.split("/");
  return urnParts[urnParts.length - 1];
};

export var retrieveColorLogos = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client, logos) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", retrieveLogos(client, logos));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function retrieveColorLogos(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var retrieveMonoLogos = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client, logos) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", retrieveLogos(client, logos, "logoMono"));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function retrieveMonoLogos(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var retrieveLogos = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(client) {
    var logos,
        logoField,
        logoIds,
        companyLogoResponse,
        integrationLogoResponse,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            logos = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : [];
            logoField = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : "logoColor";
            logoIds = logos.map(function (logo) {
              return deriveIdFromUrn(logo.sys.urn);
            });
            _context3.next = 5;
            return client.get("".concat(COMPANY_COMPANY_LOGO_URL_PATH, "?select=sys.id,fields.").concat(logoField, "&sys.id[in]=").concat(logoIds.join(","), "&order=sys.id"));

          case 5:
            companyLogoResponse = _context3.sent;
            _context3.next = 8;
            return client.get("".concat(INTEGRATION_COMPANY_LOGO_URL_PATH, "?select=sys.id,fields.").concat(logoField, "&sys.id[in]=").concat(logoIds.join(","), "&order=sys.id"));

          case 8:
            integrationLogoResponse = _context3.sent;
            return _context3.abrupt("return", companyLogoResponse.concat(integrationLogoResponse).map(function (logo) {
              return convertAssetToMedia(logo[logoField]);
            }));

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function retrieveLogos(_x5) {
    return _ref3.apply(this, arguments);
  };
}();

export var retrieveCards = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(client) {
    var cardResources,
        cardResrourceIds,
        cardResponse,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            cardResources = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : [];
            cardResrourceIds = cardResources.map(function (cardResource) {
              return deriveIdFromUrn(cardResource.sys.urn);
            });
            _context4.next = 4;
            return client.get("".concat(CARD_URL_PATH, "?sys.id[in]=").concat(cardResrourceIds.join(","), "&order=sys.id"));

          case 4:
            cardResponse = _context4.sent;
            return _context4.abrupt("return", cardResponse.map(function (card) {
              return {
                heading: card.cardHeading,
                description: card.cardDescription,
                url: card.cardUrl,
                ctaLinkText: card.cardCtaText
              };
            }));

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function retrieveCards(_x6) {
    return _ref4.apply(this, arguments);
  };
}();
export var retrieveEmbeddedVideos = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(client) {
    var embeddedVideoResources,
        embeddedVideoResourceIds,
        embeddedVideoResponse,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            embeddedVideoResources = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : [];
            embeddedVideoResourceIds = embeddedVideoResources.map(function (embeddedVideoResource) {
              return deriveIdFromUrn(embeddedVideoResource.sys.urn);
            });
            _context5.next = 4;
            return client.get("".concat(EMBED_VIDEO_URL_PATH, "?sys.id[in]=").concat(embeddedVideoResourceIds.join(","), "&order=sys.id"));

          case 4:
            embeddedVideoResponse = _context5.sent;
            return _context5.abrupt("return", embeddedVideoResponse);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function retrieveEmbeddedVideos(_x7) {
    return _ref5.apply(this, arguments);
  };
}();
export var retrieveDownloadOnSubmitForms = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(client) {
    var downloadOnSubmitResources,
        downloadOnSubmitResourceIds,
        downloadOnSubmitResponse,
        _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            downloadOnSubmitResources = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : [];
            downloadOnSubmitResourceIds = downloadOnSubmitResources.map(function (downloadOnSubmitResource) {
              return deriveIdFromUrn(downloadOnSubmitResource.sys.urn);
            });
            _context6.next = 4;
            return client.get("".concat(DOWNLOAD_ON_SUBMIT_FORM_URL_PATH, "?sys.id[in]=").concat(downloadOnSubmitResourceIds.join(","), "&order=sys.id"));

          case 4:
            downloadOnSubmitResponse = _context6.sent;
            return _context6.abrupt("return", downloadOnSubmitResponse);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function retrieveDownloadOnSubmitForms(_x8) {
    return _ref6.apply(this, arguments);
  };
}();

var convertRobotRestrictionsToDirective = function convertRobotRestrictionsToDirective(restrictions) {
  if (restrictions === "All robots restrictions") {
    return "noindex, nofollow, noarchive, nosnippet, noimageindex";
  }

  return "all";
};

export var convertSeoMetaResponseToSeoMeta = function convertSeoMetaResponseToSeoMeta(seoMetaResponse) {
  if (!seoMetaResponse) {
    return {
      pageTitle: "",
      pageDescription: "",
      robotsDirective: "",
      ogImage: {
        title: "",
        src: ""
      }
    };
  }

  return _objectSpread(_objectSpread({}, seoMetaResponse), {}, {
    pageDescription: _get(seoMetaResponse, "pageDescription", ""),
    pageTitle: _get(seoMetaResponse, "pageTitle", ""),
    robotsDirective: convertRobotRestrictionsToDirective(_get(seoMetaResponse, "robotsRestrictions", "")),
    ogImage: {
      title: _get(seoMetaResponse, "ogImage.fields.title", ""),
      src: _get(seoMetaResponse, "ogImage.fields.file.url", "")
    }
  });
};